import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Layout, Monitor, Smartphone, Tablet, X } from "lucide-react";

const devices = [
    { id: "desktop", label: "Desktop", width: "100%", icon: Monitor },
    { id: "tablet", label: "Tablet", width: "768px", icon: Tablet },
    { id: "mobile", label: "Mobile", width: "390px", icon: Smartphone },
];

export default function DevicePanel() {
    const [open, setOpen] = useState(false);
    const [device, setDevice] = useState("desktop");
    const active = devices.find((d) => d.id === device);

    return (
        <>
            <button
                data-testid="device-panel-toggle"
                onClick={() => setOpen(!open)}
                className="fixed bottom-6 left-6 z-[60] hidden items-center gap-2 border border-paper/25 bg-ink/90 px-4 py-2.5 font-mono text-[9px] uppercase tracking-[0.2em] text-paper/80 backdrop-blur-sm transition-colors duration-300 hover:border-accent hover:text-accent sm:flex"
            >
                <Layout size={13} />
                Visualizar projeto
            </button>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 24 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        data-testid="device-panel"
                        className="fixed bottom-20 left-6 z-[60] w-80 border border-line bg-paper shadow-xl"
                    >
                        <div className="flex items-center justify-between border-b border-line px-4 py-3">
                            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink">
                                Pré-visualização do projeto
                            </p>
                            <button
                                data-testid="device-panel-close"
                                aria-label="Fechar painel"
                                onClick={() => setOpen(false)}
                                className="text-ink-soft transition-colors hover:text-ink"
                            >
                                <X size={15} />
                            </button>
                        </div>
                        <div className="flex gap-2 p-4">
                            {devices.map((d) => {
                                const Icon = d.icon;
                                return (
                                    <button
                                        key={d.id}
                                        data-testid={`device-${d.id}`}
                                        onClick={() => setDevice(d.id)}
                                        className={`flex flex-1 flex-col items-center gap-1.5 border px-2 py-3 transition-colors duration-300 ${
                                            device === d.id
                                                ? "border-accent bg-accent/10 text-accent"
                                                : "border-line text-ink-soft hover:border-ink/30"
                                        }`}
                                    >
                                        <Icon size={16} />
                                        <span className="font-mono text-[9px] uppercase tracking-[0.15em]">
                                            {d.label}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                        <div className="flex justify-center border-t border-line bg-cream p-4">
                            <div
                                className="overflow-hidden border border-line-dark bg-paper transition-all duration-500"
                                style={{
                                    width: active.width,
                                    height: device === "desktop" ? 160 : 240,
                                    maxWidth: "100%",
                                }}
                            >
                                <iframe
                                    title="Pré-visualização do projeto"
                                    src={window.location.href}
                                    className="h-full w-full border-0"
                                />
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
